import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { ApplicationResponse } from "@src/common/domain/common.model"
import api from "@src/common/services/api.service"
import AppConstants from "@src/utils/app.constants"
import { EscStore, NewEscModelRef } from "../domain/ecs.model"
export const addEscList = createAsyncThunk<void, any>("esc/addEsc",
 async (payload: any) => {
    const response = await api.post<ApplicationResponse<NewEscModelRef[]>>(`${AppConstants.api}/esc`, payload)
})
export const updateEscList = createAsyncThunk<void, any>("esc/updateEsc",
 async (payload: any) => {
    const response = await api.put<ApplicationResponse<NewEscModelRef[]>>(`${AppConstants.api}/esc`, payload)
})
export const deleteEsc = createAsyncThunk(
  "esc/deleteEsc",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/esc?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
export const fetchEscList = createAsyncThunk<any[], void> ("esc/fetchEsc",
    async () => {

        const response = await api.get<ApplicationResponse<NewEscModelRef[]>>(`${AppConstants.api}/esc`)
        return response.data.data || []
        // return  [ 
        //     {
        //         ecsName: "MSIL",
        //         ecsCode: "UIG",
        //         status: "Active"
        //     },
        //     {
        //         ecsName: "SMG",
        //         ecsCode: "UIG",
        //         status: "Active"
        //     },
        //     {
        //         ecsName: "HMCL",
        //         ecsCode: "CIG",
        //         status: "Active"
        //     },
        // ]
    })
  
const escSlice = createSlice({
    name: "esc",
    initialState: {minimal: {status: "loading", error: null, data: []}} as EscStore,
    reducers: {
       
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEscList.pending, (state, action) => {
                state.minimal = {
                    status: "loading",
                    data: [],
                    error: null
                }
            })
            .addCase(fetchEscList.fulfilled, (state, action) => {
                state.minimal = {
                    status: "idle",
                    data: action.payload,
                    error: null
                }
            })
            .addCase(fetchEscList.rejected, (state, action) => {
                state.minimal = {
                    status: "failed",
                    data: [],
                    error: action.error
                }
            })

    }
})

export default escSlice.reducer
